import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';

import axios from './axios';

export interface UseDeleteWebinarVariables {
  allOccurances?: boolean;
  id: number;
}

export interface UseDeleteWebinarData {}

export function useDeleteWebinar() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseDeleteWebinarData,
    AxiosError<never>,
    UseDeleteWebinarVariables
  >(
    (variables) => {
      const { allOccurances, id } = variables;

      return axios
        .delete<UseDeleteWebinarData>(
          `/posht/yashar/webinars/${allOccurances ? 'recurrence/' : ''}${id}/`,
        )
        .then((res) => res.data);
    },
    {
      onError: (error, variables, context) => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSettled: () => {
        queryClient.invalidateQueries('upcoming-webinars');
        queryClient.invalidateQueries('previous-webinars');
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
